export default "__VITE_ASSET__ChYbNniT__"